var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"qrcode",staticClass:"qrcode",style:({ border: 'solid 10px ' + _vm.color })},[(_vm.showLabel)?_c('div',{staticClass:"leiamais"},[_vm._v("LEIA MAIS!")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }